
function handleHover(event) {
    const handle = event.currentTarget.dataset.handle;
    const menus = document.querySelectorAll(".nav__menu-dropdown");
    if (!handle) {
        console.error("Cannot find menu handle");
        return;
    }

    for (const menu of menus) {
        menu.classList.remove("show");
        if (menu.dataset.handle == handle) {
            menu.classList.add("show");
        }
    }

}

function handleLeaving(event) {
    const menus = document.querySelectorAll(".nav__menu-dropdown");
    for (const menu of menus) {
        menu.classList.remove("show");
    }
}

function menuAddListeners() {
    const items = document.querySelectorAll("li.primary-nav__item");
    items.forEach((item) => {
        item.addEventListener("mouseover", handleHover);
    });

    const menus = document.querySelectorAll("div.nav__menu-wrapper");
    menus.forEach((menu) => {
        menu.addEventListener("mouseleave", handleLeaving);
    })

    const overlays = document.querySelectorAll("div.nav__menu-overlay");
    overlays.forEach((overlays) => {
        overlays.addEventListener("mouseover", handleLeaving);
    })
}

document.addEventListener("DOMContentLoaded", () => {
    menuAddListeners();
})